<div *ngIf="isFetchingAnydayData" class="anyday-price-loading">
    <app-loading-dots></app-loading-dots>
</div>

<div [hidden]="isFetchingAnydayData" #anydayPriceHolderEl class="anyday-price-holder"></div>
